module.exports = __webpack_public_path__ + "assets/img/5_1370.4bdfa828.jpg";